import { ApiProperty } from '@nestjs/swagger';

import { UpdateInputModel } from './update-input.model';

export class FileInputModel extends UpdateInputModel {
  @ApiProperty({ type: String, format: 'binary' })
  public file!: any;
}
